<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mt-1">
        <h1 class="m-0 p-0">Actualizează Document Oficial</h1>
        <button type="button" class="action-btn d-flex p-0" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <!-- <div class="row">
            <mat-form-field appearance="fill">
                <mat-label>ID Template</mat-label>
                <input type="text" matInput formControlName="template_id" />
            </mat-form-field>
        </div> -->
        <!-- this we need to hide please.. no needed -->
        <!-- <div class="row">
            <mat-form-field appearance="fill">
                <mat-label>Valabil</mat-label>
                <input matInput [matDatepicker]="pickerValabil" formControlName="valability" readonly
                    (focus)="pickerValabil.open()" />
                <mat-hint>ZZ/LL/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                <mat-datepicker #pickerValabil></mat-datepicker>
            </mat-form-field>
        </div> -->
        <!-- <div class="row">
            <angular-editor formControlName="content" [config]="editorConfig"></angular-editor>
        </div> -->

        <!-- doc_type == 2 sticks -->
        <ng-container *ngIf="data.doc_type == 2">
            <br />
            <div>
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event)" value="toPrimarie">
                    <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
                    <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
                    <mat-button-toggle value="toate">Toate</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <br />
        </ng-container>

        <!-- Header/Footer Selection Panel -->
        <mat-expansion-panel class="mb-3">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-icon class="me-2">description</mat-icon>
                    Antet și Subsol Document
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="row">
                <!-- Header Selection -->
                <div class="col-md-6">
                    <div class="d-flex align-items-center mb-2">
                        <mat-checkbox formControlName="use_header" color="primary">
                            Utilizează antet
                        </mat-checkbox>
                    </div>
                    <mat-form-field class="w-100" appearance="fill" *ngIf="form.get('use_header')?.value">
                        <mat-label>Selectează Antet</mat-label>
                        <mat-select formControlName="header_id">
                            <mat-option [value]="null">-- Fără antet --</mat-option>
                            <mat-option *ngFor="let header of availableHeaders" [value]="header.id">
                                {{ header.name }} {{ header.is_default ? '(Default)' : '' }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Footer Selection -->
                <div class="col-md-6">
                    <div class="d-flex align-items-center mb-2">
                        <mat-checkbox formControlName="use_footer" color="primary">
                            Utilizează subsol
                        </mat-checkbox>
                    </div>
                    <mat-form-field class="w-100" appearance="fill" *ngIf="form.get('use_footer')?.value">
                        <mat-label>Selectează Subsol</mat-label>
                        <mat-select formControlName="footer_id">
                            <mat-option [value]="null">-- Fără subsol --</mat-option>
                            <mat-option *ngFor="let footer of availableFooters" [value]="footer.id">
                                {{ footer.name }} {{ footer.is_default ? '(Default)' : '' }}
                                {{ footer.show_pagination ? '(cu paginare)' : '' }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </mat-expansion-panel>

        <div class="row">
            <div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
                <br />
                <div class="col">
                    <h2 class="fw-bold">Exemplar Semnatari</h2>
                    <br />
                    <app-rich-editor formControlName="content" [minHeight]="'400px'"></app-rich-editor>
                </div>
            </div>
            <div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
                <br />
                <div class="col">
                    <h2 class="fw-bold">Exemplar Cetățean</h2>
                    <br />
                    <app-rich-editor formControlName="content_citizen" [minHeight]="'400px'"></app-rich-editor>
                </div>
            </div>
        </div>
        <br />

        <div class="row">
            <div class="col">
                <div class="d-flex justify-content-end">
                    <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                        {{ helper.dialogConfig.buttonLabels.close }}
                    </button>
                    <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                        {{ helper.dialogConfig.buttonLabels.save }}
                    </button>
                </div>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>